import React, { useState } from "react";
import { useAuth } from "component/UseAuth";
import axios from "axios";
import { showSuccess, showError } from "component/utils/SweetAlert";
import DataTable from "react-data-table-component";
import DatatableStyles, { scrollableTableContainer } from "component/utils/DatatableStyles";
import { formatRupiah } from "component/utils/formatRupiah";

import LovCoA from "component/akunting/transaksi/jurnal-umum/LovCoA";

const paginationOptions = {
  rowsPerPageText: "Tampilkan per halaman:",
  rangeSeparatorText: "dari",
};

const JurnalDetailTable = ({
  data,
  onAddRow,
  onChangeRow,
  onRemoveRow,
  isViewMode,
  onBack,
}) => {
  const { user } = useAuth();
  const [search, setSearch] = useState("");
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [CoA, setCoA] = useState([]);

  const filteredData = data.filter((item) =>
    Object.values(item).some((field) =>
      field?.toString().toLowerCase().includes(search.toLowerCase())
    )
  );

  const handleOpsiClick = async (index) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API}/show-lov-coa-pendrek`,
        {
          reg_desc: user?.company,
        }
      );
      setCoA(res.data.data);
      setSelectedRowIndex(index);
      setShowModal(true);
    } catch (err) {
      showError("Gagal mengambil data LOV");
    }
  };

  const handleSelectData = (selectedData) => {
    if (selectedRowIndex === null) return;

    const updatedData = [...data];
    updatedData[selectedRowIndex] = {
      ...updatedData[selectedRowIndex],
      group_account_table: selectedData.group_account_table,
      group_account_div: selectedData.group_account_div,
      chart_account_code: selectedData.chart_account_code,
      chart_account_desc: selectedData.chart_account_desc,
      entry_by: user?.name,
      lokasi: user?.company,
    };

    onChangeRow(selectedRowIndex, null, updatedData[selectedRowIndex]); // trigger update di parent
    setShowModal(false);
    setSelectedRowIndex(null);
  };

  const columns = [
    { name: "No", selector: (_, index) => index + 1, minWidth: "50px", maxWidth: "70px", center: true }, 
    {
      name: "Chart Code",
      cell: (row, index) =>
        isViewMode ? (
          row.chart_account_code
        ) : (
          <div className="d-flex align-items-center gap-2">
            <input
              className="form-control form-control-sm"
              value={row.chart_account_code}
              onChange={(e) => onChangeRow(index, "chart_account_code", e.target.value)}
            />
            <button
              type="button"
              className="btn btn-sm btn-secondary"
              onClick={() => handleOpsiClick(index)}
              title="Opsi lainnya"
            >
              <i className="fa fa-ellipsis-h"></i>
            </button>
          </div>
        ),
      sortable: true,
      minWidth: "130px",
    },
    {
      name: "Chart Account Desc",
      cell: (row, index) =>
        isViewMode ? (
          row.chart_account_desc
        ) : (
          <input
            className="form-control form-control-sm"
            value={row.chart_account_desc}
            onChange={(e) => onChangeRow(index, "chart_account_desc", e.target.value)}
          />
        ),
      sortable: true,
      minWidth: "250px",
    },
    {
      name: "Debit",
      omit: true,
      cell: (row, index) =>
        isViewMode ? (
          formatRupiah(row.debit)
        ) : (
          <input
            type="text"
            className="form-control form-control-sm"
            value={formatRupiah(row.debit || "0")}
            onChange={(e) => {
              onChangeRow(index, "debit", e.target.value);
              if (e.target.value) onChangeRow(index, "credit", "0");
            }}
            disabled={!!row.credit}
          />
        ),
      minWidth: "130px",
    },
    {
      name: "Credit",
      cell: (row, index) =>
        isViewMode ? (
          formatRupiah(row.credit)
        ) : (
          <input
            type="text"
            className="form-control form-control-sm"
            value={formatRupiah(row.credit || 0)}
            onChange={(e) => {
              onChangeRow(index, "credit", e.target.value);
              if (e.target.value) onChangeRow(index, "debit", "0");
            }}
            disabled={!!row.debit}
          />
        ),
      minWidth: "130px",
    },
    !isViewMode && {
      name: "Aksi",
      cell: (_, index) => (
        <button
          className="btn btn-sm btn-danger rounded-circle"
          onClick={() => onRemoveRow(index)}
        >
          <i className="bx bx-trash"></i>
        </button>
      ),
      minWidth: "50px",
      maxWidth: "70px",
      center: true,
    },
  ].filter(Boolean);

  return (
    <div className="mt-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        {isViewMode ? (
          <button className="btn btn-secondary btn-sm" onClick={onBack}>
            <i className="bx bx-arrow-back"></i> Kembali
          </button>
        ) : (
          <button className="btn btn-primary btn-sm" onClick={onAddRow}>
            <i className="bx bx-plus"></i> Tambah Baris
          </button>
        )}
      </div>

      <div style={scrollableTableContainer}>
        <DataTable
          columns={columns}
          data={filteredData}
          noDataComponent="Belum ada data."
          pagination
          paginationPerPage={5}
          paginationRowsPerPageOptions={[5, 10, 25]}
          paginationComponentOptions={paginationOptions}
          customStyles={DatatableStyles}
          highlightOnHover
          responsive={false}
        />
      </div>

      {showModal && (
        <LovCoA
          show={showModal}
          data={CoA}
          onClose={() => {
            setShowModal(false);
            setSelectedRowIndex(null);
          }}
          onSelect={handleSelectData}
        />
      )}
    </div>
  );
};

export default JurnalDetailTable;
